import { z } from 'zod';

const authConfigSchema = z.object({
    clientId: z.string().optional(),
    redirectUri: z.string().optional(),
    postLogoutRedirectUri: z.string().optional(),
    redirectUriAsPostLogoutRedirectUriFallback: z.boolean().optional(),
    loginUrl: z.string().optional(),
    scope: z.string().optional(),
    resource: z.string().optional(),
    rngUrl: z.string().optional(),
    oidc: z.boolean().optional(),
    requestAccessToken: z.boolean().optional(),
    options: z.any().optional(),
    issuer: z.string().optional(),
    logoutUrl: z.string().optional(),
    clearHashAfterLogin: z.boolean().optional(),
    tokenEndpoint: z.string().optional(),
    revocationEndpoint: z.string().optional(),
    customTokenParameters: z.array(z.string()).optional(),
    userinfoEndpoint: z.string().optional(),
    responseType: z.string().optional(),
    showDebugInformation: z.boolean().optional(),
    silentRefreshRedirectUri: z.string().optional(),
    silentRefreshMessagePrefix: z.string().optional(),
    silentRefreshShowIFrame: z.boolean().optional(),
    siletRefreshTimeout: z.number().optional(),
    silentRefreshTimeout: z.number().optional(),
    dummyClientSecret: z.string().optional(),
    requireHttps: z.union([z.boolean(), z.literal('remoteOnly')]).optional(),
    strictDiscoveryDocumentValidation: z.boolean().optional(),
    jwks: z.any().optional(),
    customQueryParams: z.any().optional(),
    silentRefreshIFrameName: z.string().optional(),
    timeoutFactor: z.number().optional(),
    sessionChecksEnabled: z.boolean().optional(),
    sessionCheckIntervall: z.number().optional(),
    sessionCheckIFrameUrl: z.string().optional(),
    sessionCheckIFrameName: z.string().optional(),
    disableAtHashCheck: z.boolean().optional(),
    skipSubjectCheck: z.boolean().optional(),
    useIdTokenHintForSilentRefresh: z.boolean().optional(),
    skipIssuerCheck: z.boolean().optional(),
    fallbackAccessTokenExpirationTimeInSec: z.number().optional(),
    nonceStateSeparator: z.string().optional(),
    useHttpBasicAuth: z.boolean().optional(),
    clockSkewInSec: z.number().optional(),
    decreaseExpirationBySec: z.number().optional(),
    waitForTokenInMsec: z.number().optional(),
    useSilentRefresh: z.any().optional(),
    disablePKCE: z.boolean().optional(),
    preserveRequestedRoute: z.boolean().optional(),
    disableIdTokenTimer: z.boolean().optional(),
    checkOrigin: z.boolean().optional(),
    openUri: z.function({ input: [z.string()], output: z.void() }).optional(),
});

const sentinelAuthProviderConfigSchema = z.object({
    label: z.string().optional(),
    textColor: z.string().optional(),
    backgroundColor: z.string().optional(),
    oidcConfig: authConfigSchema.optional(),
});

export const sentinelAuthConfigSchema = z.object({
    authorizationStrategyConfig: z.any().optional(),
    logoutStrategyConfig: z.any().optional(),
    guardLoginPageRedirect: z.string().optional(),
    guardMainPageRedirect: z.string().optional(),
    interceptorAllowedUrls: z.array(z.string()).optional(),
    navigateToRequestedRoutePostLogin: z.boolean().optional(),
    providers: z.array(sentinelAuthProviderConfigSchema).optional(),
});
